import { Injectable } from '@angular/core';
import { ColumnsDefinition, CustomGridSettings, DataSource, GridEvent, GridState } from './grid.models';


@Injectable()
export class GridBuilderService {
    private settings: CustomGridSettings = new CustomGridSettings();

    constructor() {
        this.settings.columnDefs = [];
    }    

    reset() {
        this.settings.columnDefs = [];
    }

    AddColumn(name: string, options: (column: ColumnsDefinition) => void = null): GridBuilderService {

        let column = new ColumnsDefinition();

        column.field = name;
        column.headerName = name;
        column.sortProperty = name;
        column.dataSource = new DataSource();

        if (!!options) {
            options(column);
        }

        this.settings.columnDefs.push(column);

        return this;
    }

    addEvent(options: (options: GridEvent) => void): GridBuilderService {

        let event = new GridEvent();

        options(event);

        this.settings.events.push(event);

        return this;
    }

    withState(options: (state: GridState) => void): GridBuilderService {
        options(this.settings.state);

        return this;
    }

    withData(data: any[]): GridBuilderService {
        this.settings.rowData = data;
        return this;
    }

    withTotalRows(totalRows: number): GridBuilderService {
        this.settings.totalRows = totalRows;

        return this;
    }

    withTotalNotSubmittedRows(totalNotSubmitedRows: number): GridBuilderService {
        this.settings.totalNotSubmitedRows = totalNotSubmitedRows;

        return this;
    }

    withoutSearch(): GridBuilderService {
        this.settings.showSearch = false;

        return this;
    }

    withRowEditable(isEditable: (item: any) => boolean): GridBuilderService {
        this.settings.isEditable = isEditable;
        return this;
    }
    
    allowDownloadFile(allow: boolean = true): GridBuilderService {
        this.settings.allowDownloadFile = allow;
        return this;
    }

    allowPrint(): GridBuilderService {
        this.settings.allowPrint = true;
        return this;
    }

    changeTitle(title: string): GridBuilderService {
        this.settings.title = title;
        return this;
    }

    build(): CustomGridSettings {
        return this.settings;
    }    
}
